<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-group"/> {{caption}}
        <div class="card-header-actions">
          <CButton color="info" size="sm" @click="storeModal()">Nueva Unidad</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable 
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        pagination
      >
        <template #code="{item}"><td class="w100 text-center">{{item.code}}</td></template>
        <template #name="{item}"><td>{{item.name}}</td></template>
        <template #actions="{item}">
          <td class="table_actions b2">
            <CButton color="warning" size="sm" @click="updateModal(item)"><CIcon name="cil-pencil"/></CButton>
            <CButton color="danger" size="sm" @click="deleteModal(item)"><CIcon name="cil-trash"/></CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <UnitModal ref="unitModal" @store="storeProcess" @update="updateProcess"></UnitModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import UnitModal from './UnitModal.vue'
import DeleteModal from '../../global/DeleteModal.vue'
import ws from '../../../services/units';
import store from '../../../store'

export default {
  name: 'UnitsTable',
  components: { UnitModal, DeleteModal }, 
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        return [
          {key: 'code', label: 'Código'},
          {key: 'name', label: 'Nombre'},
          {key: 'actions', label: 'Acciones', class: 'actions' },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: []
    }
  },
  methods: {
    storeModal () {
      this.$refs.unitModal.storeModal();
    },
    updateModal (item) {
      this.$refs.unitModal.updateModal(item);
    },
    deleteModal (item) {
      this.$refs.deleteModal.show("Eliminar Unidad", item.id, item.name);
    },
    async storeProcess(data) {
      let response = await ws.update(data);
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }
    },
    async updateProcess(data) {
      let response = await ws.update(data);

      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async deleteProcess(id) {
      let response = await ws.delete(id);
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async getExcel() {
      let response = await ws.excel();
      
      if(response.type == "success"){
        window.location = response.data;
      }

      this.showToast(response.type, response.message);
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    },
  }
}
</script>
